export default {
    视频: 'Video',
    产品: 'Product',
    私人定制: 'Private Customization',
    签约艺术家: 'Signed Artists',
    艺术家: 'Artist',
    新闻动态: 'News & Updates',
    关于海伦: 'About Helen',
    联系我们: 'Contact Us',
    请输入搜索关键词: 'Please enter search keywords',
    文章: 'Articles',
    敲响中国爵士鼓制造业的新乐章: "Striking a New Movement in China's Drum Manufacturing Industry",
    产品搜索: 'Product Search',
    请选择: 'Please select',
    请输入: 'Please enter',
    搜索: 'Search',
    留言给我们: 'Leave a Message',
    您的姓名: 'Your Name',
    您的电话: 'Your Phone',
    电话: 'Phone',
    留言内容: 'Message Content',
    首页: 'Home',
    数量: 'Quantity',
    库存: 'Inventory',
    音色视听: 'Tone Audio-Visual',
    立即购买: 'Buy Now',
    加入购物车: 'Add to Cart',
    参数配置: 'Parameter Configuration',
    评论: 'Comments',
    用户评论: 'User Comments',
    '没有查询到评论信息...': 'No comment information found...',
    商品不存在或已下架: 'The product does not exist or has been removed from sale',
    '商品配置有误，请检查商品配置！': 'Product configuration is incorrect, please check the product configuration!',
    没有库存了: 'Out of stock',
    请选择商品规格: 'Please select product specifications',
    '该商品库存不足,无法购买': 'Insufficient inventory, cannot purchase',
    请输入艺术家姓名搜索: 'Please enter artist name to search',
    '暂无内容...': 'No content...',
    关于艺术家: 'About Artists',
    艺术家设备: 'Artist Equipment',
    企业新闻: 'Corporate News',
    行业资讯: 'Industry Information',
    '没有查询到相关信息...': 'No relevant information found...',
    上一篇: 'Previous Article',
    下一篇: 'Next Article',
    没有了: 'No more',
    关于海伦: 'About Helen',
    公司简介: 'Company Profile',
    创始人介绍: 'Founder Introduction',
    企业荣誉: 'Corporate Honors',
    发展历程: 'Development History',
    生产线展示: 'Production Line Display',
    项: 'Item',
    爵士鼓生产线: 'Drum Set Production Line',
    电鼓生产线: 'Electronic Drum Production Line',
    欢迎关注海伦鼓尚在线平台: 'Welcome to follow the Helen Drumshang Online Platform',
    地址: 'Address',
    邮箱: 'Email',
    请输入您的姓名: 'Please enter your name',
    请输入有效的手机号: 'Please enter a valid mobile phone number',
    请输入留言内容: 'Please enter your message content',
    '留言失败，请重试！': 'Message failed, please try again!',
    个人中心: 'Personal Center',
    购物车: 'Shopping Cart',
    '登录/注册': 'Login/Register',
    返回: 'Return',
    个人中心首页: 'Personal Center Home',
    订单管理: 'Order Management',
    标准鼓订单: 'Standard Drum Orders',
    定制鼓订单: 'Custom Drum Orders',
    我的售后: 'My After-Sales',
    收藏和足迹: 'Favorites and Footprints',
    我的收藏: 'My Favorites',
    浏览足迹: 'Browsing Footprints',
    个人资料: 'Personal Information',
    地址管理: 'Address Management',
    我的发票: 'My Invoices',
    个人信息: 'Personal Information',
    修改密码: 'Change Password',
}
